module.exports = __webpack_public_path__ + "img/sm.8942c9eb.svg";